// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"boardItem_mulitpleDropdown__btdx-","task":"boardItem_task__2RZ-M","chosenTask":"boardItem_chosenTask__3VFTG","avatar":"boardItem_avatar__3zT7C"};